VjsAdmin.AdminGoogleQueue = SafeDOM.makeAdminQueueModule({ // eslint-disable-line no-undef
    tableSelector: '#google-table',
    formatNoMatchesMsg: 'No google records AT ALL!!!',
    urlRoute: 'api.admin.google.queue.fetch',
    idField: 'id',
    queuedDateField: 'created_at',
    responseHandlerCfg: {
        rowIdField: 'id',
        moveToFrontIdParam: 'id',
        hasClassesRow: true,
        cancelPermission: 'platforms.districts.google.queue.cancel',
        cancelRoute: 'platforms.districts.google.queue.cancel',
        moveToFrontPermission: 'admin.google.queue.moveToFront',
        moveToFrontRoute: 'admin.google.queue.moveToFront',
        viewPermission: 'platforms.districts.google.queue.view',
        viewRoute: 'platforms.districts.google.queue.view',
    },
});
